var exports = {
  "kL": "xa15a2ab7--87d009--container",
  "vW": "xa15a2ab7--87d009--inner",
  "nV": "xa15a2ab7--87d009--gallery",
  "wx": "xa15a2ab7--87d009--header",
  "VN": "xa15a2ab7--87d009--close",
};

module.exports = exports;
